<template>
  <div class="choose-sch">
    <ChooseAndModal
      ref="chooseSchool"
      :modal-title="modalTitle"
      :table-column="accountListColumn"
      :table-data="accountList"
      :table-total="pageInfo.total"
      :table-current="pageInfo.pageNum"
      :can-self-close="false"
      :loading="loading"
      :modal-width="1000"
      @emitSelectData="getSelectSchoolRow"
      @pageChange="handleSchoolPageChange"
    >
      <div class="search-wrap">
        <Form ref="formInline" inline>
          <FormItem>
            <Input
              v-model="searchForm.acctName"
              type="text"
              placeholder="请输入机构账户名称"
              clearable
              style="width: 200px"
            >
            </Input>
          </FormItem>
          <FormItem>
            <Select v-model="searchForm.merchantKind" style="width: 200px">
              <Option
                v-for="item in merchantKindList"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <ChooseArea
              ref="chooseAreaRef"
              @on-change="onAreaChange"
            ></ChooseArea>
          </FormItem>

          <Button type="primary" @click="handleSearch">搜索</Button>
        </Form>
      </div>
    </ChooseAndModal>
  </div>
</template>

<script>

import orderCenterApi from '@/request/orderCenter/index.js';
import ChooseAndModal from '@c/ChooseAndModal.vue';
import ChooseArea from '@c/searchBlock/ChooseArea.vue';
import { merchantKindList } from '../data/edit';
export default {
  components: {
    ChooseAndModal,
    ChooseArea

  },
  props: {
    modalTitle: {
      type: String,
      default: '选择分账对象'
    },
    divideMode2: {
      type: Array,
      default: () => []
    },
    modalWidth: {
      type: [Number, String],
      default: 70
    },
    bankId: {
      type: String,
      default: ''
    },
    merchantKindIds: {
      type: Array,
      default: []
    }

  },
  data() {
    return {
      show: false,
      // merchantKindList: [{
      //   value: '-1',
      //   label: '请选择商户身份'
      // }, {
      //   value: '1',
      //   label: '平台运营方'
      // }, {
      //   value: '3',
      //   label: '校方单位'
      // },
      // {
      //   value: '4',
      //   label: '机构单位'
      // },],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchForm: {
        acctName: '',
        merchantKind: '-1',
        areaCode: ''
      },
      portOrg: localStorage.getItem('portOrg'),
      accountListColumn: [{
        title: '机构账户名称',
        key: 'acctName',
        minWidth: 200
      },
      {
        title: '商户类别',
        key: 'merchantKindTypeName',
        width: 120
      },
      {
        title: '商户简称',
        key: 'shortName',
        minWidth: 170
      },
      {
        title: '监管银行',
        key: 'bankName',
        width: 150
      },
      {
        title: '商户身份',
        key: 'merchantKindName',
        width: 150
      },
      {
        title: '所属地区',
        key: 'areaName',
        width: 280
      }],
      accountList: [], // 表格单位列表
      selectAccountList: [], // 选中的学校列表
      loading: false,
      merchantKindMap: {
        1: '平台运营方',
        2: '渠道代理',
        3: '校方单位',
        4: '机构单位',
        5: '其它',
        6: '运营方',
        7: '平台方',
        11: '机构个人',
        12: '校方个人',
        13: '自由从业者'
      },
      isEdit: false

    };
  },
  computed: {
    merchantKindList() {
      console.log(merchantKindList, 'merchantKindList', this.merchantKindIds, this.filterMerchantKind(this.merchantKindIds));
      return this.merchantKindIds.length == 0 ? merchantKindList : this.filterMerchantKind(this.merchantKindIds);
    }
    // merchantKindList(){
    //   return bankId
    // }
  },
  created() {

  },
  methods: {
    filterMerchantKind(val) {
      const ids = [-1, ...val];
      return merchantKindList.filter(item => { return ids.includes(Number(item.value)) == true; });
    },
    initSearchForm() {
      this.searchForm.acctName = '';
      this.searchForm.merchantKind = '-1';
      this.searchForm.areaCode = '';
      this.$refs.chooseAreaRef.handleClear();
    },
    handleOpen(id) {
      this.isEdit = !!id;
      this.initSearchForm();
      this.$refs.chooseSchool.open(id);

      this.show = true;
      this.pageInfo.pageNum = 1;
      this.selectAccountList = [];
      this.getDivideConfigdFindAccountList();
    },

    getSelectSchoolRow(row) {
      console.log(row);
      const key = this.divideMode2.findIndex(item => { return item.acctNo == row.acctNo; });
      if (key == -1) {
        this.$refs.chooseSchool.close();
        this.$emit('on-finish', row);
      } else {
        this.isEdit ? this.$refs.chooseSchool.close() : this.$Message.warning('该商户已存在，请重新选择');
      }
    },
    handleSchoolPageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigdFindAccountList();
    },
    getMerchantKindTypeName(type) {
      if ([11, 12, 13].includes(Number(type))) {
        return '个人类';
      } else {
        return '企业类';
      }
    },
    handleCancel() {
      this.show = false;
    },
    handleOk(data) {
      this.$emit('on-finish', this.selectAccountList);
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigdFindAccountList();
    },
    handleDelect(row, index) {
      this.selectAccountList.splice(index, 1);
      this.accountList = this.accountList.map(item => {
        item._checked = false;
        const target = this.selectAccountList.find(item_1 => { return item_1.acctNo === item.acctNo; });
        if (target) {
          item._checked = true;
        }
        return item;
      });
    },
    // 行政区域改变
    onAreaChange(area) {
      this.searchForm.areaCode = area.length ? area[area.length - 1] : '';
    },
    // 获取机构账户列表
    async getDivideConfigdFindAccountList() {
      const params = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        acctName: this.searchForm.acctName,
        bankId: this.bankId,
        merchantKind: this.searchForm.merchantKind == -1 ? null : this.searchForm.merchantKind,
        areaCode: this.searchForm.areaCode,
        merchantKindList: this.searchForm.merchantKind == -1 && this.merchantKindIds.length > 0 ? this.merchantKindIds.join() : []
      };

      let res = {};
      this.loading = true;

      res = await orderCenterApi.getDivideConfigdFindAccountList(params);

      this.loading = false;
      if (res.status === 200) {
        this.accountList = res.message.list.map((item, index) => {
          item.id = item.acctNo ? item.acctNo : new Date().getTime() + index;
          item.merchantKindTypeName = this.getMerchantKindTypeName(item.merchantKind);
          item.merchantKindName = this.merchantKindMap[item.merchantKind] ? this.merchantKindMap[item.merchantKind] : '';
          return item;
        });
        console.log(this.accountList, 'accountList');
        this.pageInfo.total = Number(res.message.total);
      }
    },

    // 点击搜索
    handleSearch() {
      this.getDivideConfigdFindAccountList();
    },
    // 选中单个
    pickOneSch(selection, row) {
      const key = this.selectAccountList.findIndex(item => { return item.acctNo === row.acctNo; });
      if (key != -1) {
        return null;
      }
      this.selectAccountList.push(row);
      console.log(this.selectAccountList);
    },
    // 取消单个
    cancelOneSch(selection, row) {
      const key = this.selectAccountList.findIndex(item => { return item.acctNo === row.acctNo; });
      console.log(key);
      if (key != -1) {
        this.selectAccountList.splice(key, 1);
      }
    },
    // 全部选中
    pickAllSch(selection) {
      selection.forEach(item => {
        this.pickOneSch(selection, item);
      });
    },
    // 全部取消
    cancelAllSch(selection) {
      this.accountList.forEach(item => {
        this.cancelOneSch([], item);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
}
</style>
